import { createFileRoute } from '@tanstack/react-router';
import { JourneysFormsHandoff } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/forms')({
  component: JourneysFormsHandoff,
});
